import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import Err from "@Client/@Routes/error";
import Amplitude from "@Shared/@Utils/amplitude";
import ApplicationValidationsGenerator from "@Shared/@Utils/application-validation-generator";
import { DEFAULT_DISCLAIMER_ID } from "@Shared/js/constants";
import { getQuickAppSchema, getLeadLoanSchema, getLeadSchema, getWidgetDisclaimers, submitQuickAppSchema, submitLeadSchema, submitLeadLoanSchema } from "../api/widget-api";
import { SET_CURRENT_SCHEMA, SET_WIDGET_DISCLAIMERS, SET_WIDGET_SCHEMA_VALIDATIONS } from "./widget-mutations";
export const LOAD_CURRENT_SCHEMA = "LOAD_CURRENT_SCHEMA";
export const LOAD_WIDGET_DISCLAIMERS = "LOAD_WIDGET_DISCLAIMERS";
export const SUBMIT_WIDGET = "SUBMIT_WIDGET";
const actions = {
  [LOAD_CURRENT_SCHEMA]: async (context, {
    widgetType,
    flow,
    locale
  }) => {
    try {
      var _schema;
      let schema = {};
      switch (widgetType) {
        case "quick-app":
          schema = await getQuickAppSchema(flow, locale);
          break;
        case "leads":
          schema = await getLeadSchema(locale);
          break;
        case "lead-loan":
          schema = await getLeadLoanSchema(locale);
          break;
      }
      context.commit(SET_CURRENT_SCHEMA, schema);
      if ((_schema = schema) != null && _schema.schema) {
        const validationsGenerator = new ApplicationValidationsGenerator(schema.schema);
        const applicationValidations = validationsGenerator.buildWidgetValidations();
        context.commit(SET_WIDGET_SCHEMA_VALIDATIONS, {
          validations: applicationValidations
        });
      }
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_WIDGET_DISCLAIMERS]: async context => {
    try {
      const subdomain = location.pathname;
      const {
        disclaimers,
        defaultDisclaimerEnabled
      } = await getWidgetDisclaimers(subdomain);
      const onlyDisclaimers = _filterInstanceProperty(disclaimers).call(disclaimers, ({
        consent
      }) => !consent);
      const isDefaultDisclaimerEnabled = defaultDisclaimerEnabled != null ? defaultDisclaimerEnabled : onlyDisclaimers.length === 1;
      const enabledDisclaimers = _filterInstanceProperty(disclaimers).call(disclaimers, ({
        id,
        enabled = false
      }) => enabled || id === DEFAULT_DISCLAIMER_ID && isDefaultDisclaimerEnabled);
      context.commit(SET_WIDGET_DISCLAIMERS, {
        disclaimers: enabledDisclaimers
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [SUBMIT_WIDGET]: async (context, {
    widgetType,
    widgetParams,
    widgetData,
    flow
  }) => {
    try {
      let response = {};
      switch (widgetType) {
        case "quick-app":
          response = await submitQuickAppSchema(widgetData, _objectSpread(_objectSpread({}, widgetParams), {}, {
            flow
          }));
          break;
        case "leads":
          response = await submitLeadSchema(widgetData, widgetParams);
          break;
        case "lead-loan":
          response = await submitLeadLoanSchema(widgetData, widgetParams);
          break;
      }
      Amplitude.logEvent(`${widgetType} - submitted`, {
        page: "submitted"
      });
      const {
        isRegistered = null,
        applicationId = null
      } = response;
      return {
        isRegistered,
        applicationId
      };
    } catch (e) {
      Err.handle(e);
    }
  }
};
export default actions;